// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"20f1cd30","618":"67afe283","996":"74a2e2e0"}[chunkId] + ".chunk.js";
};